import { nsEnvelope } from '@/app/i18n/namespaces';
import ENVELOPE_STATUS from '../enums/EnvelopeStatus';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.created_at',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.updated_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    ACCESS_CODE: {
        key: 'accessCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.access_code',
        placeholder: 'filter.placeholder.envelopes.access_code',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    STATUS: {
        key: 'status',
        type: 'select',
        entity: 'keys.envelopes.status',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.SELECT,
        enum: ENVELOPE_STATUS
    },
    DOWNLOAD_SERVER_IP_ADDRESS_PORT: {
        key: 'downloadServerIpAddressPort',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.server_ip',
        placeholder: 'filter.placeholder.envelopes.download_server_ip_address_port',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    SCHEDULED_START_DATE: {
        key: 'scheduledStartDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.schedule_start',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    SCHEDULED_END_DATE: {
        key: 'scheduledEndDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.schedule_end',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    SENT_TO_TERMINAL_DATE: {
        key: 'sentToTerminalDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.sent_at',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    CLIENT_NAME: {
        key: 'organizationLegalName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.client',
        placeholder: 'filter.placeholder.envelopes.client_name',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    POS_TERMINAL_SERIAL_NUMBER: {
        key: 'posTerminalSerialNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.serial_number',
        placeholder: 'filter.placeholder.envelopes.serial_number',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    ORGANIZATION_UUID: {
        key: 'organizationUuid',
        type: FIELD_TYPES.TEXT
    },
    POS_TERMINAL_UUIDS: {
        key: 'posTerminalUuids',
        type: FIELD_TYPES.TEXT
    }
};